.container {
  & div:first-child {
    margin: 1.6rem 0 2.4rem 0;
  }
}

.items {
  & div:not(:last-child) {
    margin-bottom: 1.2rem;
  }

  & h3 {
    font-weight: 600;
    font-size: 1.4rem;
    color: var(--color-grayscale-light-slate);
  }

  & p {
    font-weight: 400;
    font-size: 1.4rem;
    color: var(--color-grayscale-white);
  }
}
